import React from 'react';
import PropTypes from 'prop-types';
import ProductStyles from './productStyles';

const ProductWrapper = props => {
  return <ProductStyles.WrapperStyles {...props}>{props.children}</ProductStyles.WrapperStyles>;
};

ProductWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

const Product = props => {
  return <ProductStyles {...props}>{props.children}</ProductStyles>;
};

Product.propTypes = {
  children: PropTypes.node,
};

Product.defaultProps = {
  children: undefined,
};

const ProductList = props => {
  return <ProductStyles.ListStyles {...props}>{props.children}</ProductStyles.ListStyles>;
};

ProductList.propTypes = {
  children: PropTypes.node,
};

ProductList.defaultProps = {
  children: undefined,
};

const ProductImage = props => {
  return <ProductStyles.ImageStyles {...props}>{props.children}</ProductStyles.ImageStyles>;
};

ProductImage.propTypes = {
  children: PropTypes.node,
};

ProductImage.defaultProps = {
  children: undefined,
};

const ProductContent = props => {
  return <ProductStyles.ContentStyles {...props}>{props.children}</ProductStyles.ContentStyles>;
};

ProductContent.propTypes = {
  children: PropTypes.node,
};

ProductContent.defaultProps = {
  children: undefined,
};

const ProductData = props => {
  return <ProductStyles.DataStyles {...props}>{props.children}</ProductStyles.DataStyles>;
};

ProductData.propTypes = {
  children: PropTypes.node,
};

ProductData.defaultProps = {
  children: undefined,
};

Product.Wrapper = ProductWrapper;
Product.List = ProductList;
Product.Image = ProductImage;
Product.Content = ProductContent;
Product.Data = ProductData;

export default Product;
